import yn from 'yn'

export const mainApiUrl = (import.meta.env.VITE_MAIN_API_URL || '').replace(/\/$/, '')
export const localApiUrl = (import.meta.env.VITE_LOCAL_API_URL || '').replace(/\/$/, '')

export const wsApiUrl = (import.meta.env.VITE_WS_URL || '').replace(/\/$/, '')

export const storeChunkSize = Number(import.meta.env.VITE_STORE_CHUNK_SIZE || 5)

const store = (window.appConfig || {}).store || {}

export const storeId = store.id

export const baseHeaders = { 'Accept': 'application/json', 'Content-Type': 'application/json' }

export const userTimezone = (Intl && Intl.DateTimeFormat) ? Intl.DateTimeFormat().resolvedOptions().timeZone : 'UTC'

export const paletteColors = [ [245, 34, 45], [250, 140, 22], [250, 219, 20], [139, 187, 17], [82, 196, 26], [19, 168, 168], [22, 119, 255], [47, 84, 235], [114, 46, 209], [235, 47, 150],
  [250, 144, 150], [252, 197, 138], [252, 237, 137], [197, 221, 136], [168, 225, 140], [137, 211, 211], [138, 187, 255], [151, 169, 245], [184, 150, 232], [245, 151, 202], [0, 0, 0],
  [64, 64, 64], [128, 128, 128], [255, 255, 255] ]

export const locales = [
  { slug: 'es' },
  { slug: 'en' },
  { slug: 'pt' },
  { slug: 'ca' },
  { slug: 'fr' },
]

export const countries = [
  { slug: 'ad', label: 'Andorra' },
  { slug: 'ar', label: 'Argentina' },
  { slug: 'cl', label: 'Chile' },
  { slug: 'es', label: 'España' },
  { slug: 'br', label: 'Brasil' },
  { slug: 'pe', label: 'Perú' },
  { slug: 'ec', label: 'Ecuador' },
  { slug: 'pa', label: 'Panamá' },
  { slug: 'mx', label: 'México' },
  { slug: 'uy', label: 'Uruguay' },
  { slug: 'us', label: 'Estados Unidos' },
]

export const paymentStatusOptions = [
  { key: 'approved', text: 'approved', value: 'approved', icon: 'payment', color: 'yellow' },
  { key: 'charged_back', text: 'charged_back', value: 'charged_back', icon: 'redo', color: 'blue' },
  { key: 'completed', text: 'paid', value: 'completed', icon: 'check', color: 'green' },
  { key: 'in_process', text: 'in_process', value: 'in_process', icon: 'clock', color: 'blue' },
  { key: 'pending', text: 'pending', value: 'pending', icon: 'clock', color: 'red' },
  { key: 'in_mediation', text: 'in_mediation', value: 'in_mediation', icon: 'clock', color: 'red' },
  { key: 'refunded', text: 'refunded', value: 'refunded', icon: 'redo', color: 'blue' },
  { key: 'rejected', text: 'rejected', value: 'rejected', icon: 'close', color: 'red' },
  { key: 'canceled', text: 'canceled', value: 'canceled', icon: 'close', color: 'red' },
]

export const paymentMethodsOptions = [
  { key: 'cash', text: 'cash', value: 'cash', icon: 'money', color: 'red' },
  { key: 'decidir', text: 'decidir', value: 'decidir', icon: 'payment', color: 'yellow' },
  { key: 'mercado_pago', text: 'mercado_pago', value: 'mercado_pago', icon: 'payment', color: 'yellow' },
  { key: 'transbank', text: 'transbank', value: 'transbank', icon: 'payment', color: 'yellow' },
  { key: 'redsys', text: 'redsys', value: 'redsys', icon: 'payment', color: 'yellow' },
  { key: 'paypal', text: 'paypal', value: 'paypal', icon: 'paypal card', color: 'green' },
  { key: 'gift', text: 'gift', value: 'gift', icon: 'gift', color: 'blue' },
  { key: 'bank_transfer', text: 'bank_transfer', value: 'bank_transfer', icon: 'building', color: 'red' },
  { key: 'pix', text: 'pix', value: 'pix', icon: 'payment', color: 'blue' },
  { key: 'posnet', text: 'posnet', value: 'posnet', icon: 'calculator', color: 'red' },
]

export const currencies = [
  { slug: 'ars',  amountKeyLowerCase: 'amount_ars', maxAmountKeyLowerCase: 'max_amount_ars', amountKey: 'amountArs', maxAmountKey: 'maxAmountArs', originalTotalKeyLowerCase: 'original_total_ars', originalTotalKey: 'originalTotalArs', totalKeyLowerCase: 'total_ars', priceKeyLowerCase: 'price_ars', totalKey: 'totalArs', priceKey: 'priceArs', photoPriceKeyLowerCase: 'photo_price_ars', photoPriceKey: 'photoPriceArs', label: 'ARS', sign: '$' },
  { slug: 'usd',  amountKeyLowerCase: 'amount_usd', maxAmountKeyLowerCase: 'max_amount_usd', amountKey: 'amountUsd', maxAmountKey: 'maxAmountUsd', originalTotalKeyLowerCase: 'original_total_usd', originalTotalKey: 'originalTotalUsd', totalKeyLowerCase: 'total_usd', priceKeyLowerCase: 'price_usd', totalKey: 'totalUsd', priceKey: 'priceUsd', photoPriceKeyLowerCase: 'photo_price_usd', photoPriceKey: 'photoPriceUsd', label: 'USD', sign: '$' },
  { slug: 'eur',  amountKeyLowerCase: 'amount_eur', maxAmountKeyLowerCase: 'max_amount_eur', amountKey: 'amountEur', maxAmountKey: 'maxAmountEur', originalTotalKeyLowerCase: 'original_total_eur', originalTotalKey: 'originalTotalEur', totalKeyLowerCase: 'total_eur', priceKeyLowerCase: 'price_eur', totalKey: 'totalEur', priceKey: 'priceEur', photoPriceKeyLowerCase: 'photo_price_eur', photoPriceKey: 'photoPriceEur', label: 'EUR', sign: '€' },
  { slug: 'clp',  amountKeyLowerCase: 'amount_clp', maxAmountKeyLowerCase: 'max_amount_clp', amountKey: 'amountClp', maxAmountKey: 'maxAmountClp', originalTotalKeyLowerCase: 'original_total_clp', originalTotalKey: 'originalTotalClp', totalKeyLowerCase: 'total_clp', priceKeyLowerCase: 'price_clp', totalKey: 'totalClp', priceKey: 'priceClp', photoPriceKeyLowerCase: 'photo_price_clp', photoPriceKey: 'photoPriceClp', label: 'CLP', sign: '$' },
  { slug: 'brl',  amountKeyLowerCase: 'amount_brl', maxAmountKeyLowerCase: 'max_amount_brl', amountKey: 'amountBrl', maxAmountKey: 'maxAmountBrl', originalTotalKeyLowerCase: 'original_total_brl', originalTotalKey: 'originalTotalBrl', totalKeyLowerCase: 'total_brl', priceKeyLowerCase: 'price_brl', totalKey: 'totalBrl', priceKey: 'priceBrl', photoPriceKeyLowerCase: 'photo_price_brl', photoPriceKey: 'photoPriceBrl', label: 'BRL', sign: 'R$' },
  { slug: 'pen',  amountKeyLowerCase: 'amount_pen', maxAmountKeyLowerCase: 'max_amount_pen', amountKey: 'amountPen', maxAmountKey: 'maxAmountPen', originalTotalKeyLowerCase: 'original_total_pen', originalTotalKey: 'originalTotalPen', totalKeyLowerCase: 'total_pen', priceKeyLowerCase: 'price_pen', totalKey: 'totalPen', priceKey: 'pricePen', photoPriceKeyLowerCase: 'photo_price_pen', photoPriceKey: 'photoPricePen', label: 'PEN', sign: 'S/' },
  { slug: 'mxn',  amountKeyLowerCase: 'amount_mxn', maxAmountKeyLowerCase: 'max_amount_mxn', amountKey: 'amountMxn', maxAmountKey: 'maxAmountMxn', originalTotalKeyLowerCase: 'original_total_mxn', originalTotalKey: 'originalTotalMxn', totalKeyLowerCase: 'total_mxn', priceKeyLowerCase: 'price_mxn', totalKey: 'totalMxn', priceKey: 'priceMxn', photoPriceKeyLowerCase: 'photo_price_mxn', photoPriceKey: 'photoPriceMxn', label: 'MXN', sign: '$' },
  { slug: 'cop',  amountKeyLowerCase: 'amount_cop', maxAmountKeyLowerCase: 'max_amount_cop', amountKey: 'amountCop', maxAmountKey: 'maxAmountCop', originalTotalKeyLowerCase: 'original_total_cop', originalTotalKey: 'originalTotalCop', totalKeyLowerCase: 'total_cop', priceKeyLowerCase: 'price_cop', totalKey: 'totalCop', priceKey: 'priceCop', photoPriceKeyLowerCase: 'photo_price_cop', photoPriceKey: 'photoPriceCop', label: 'COP', sign: '$' },
  { slug: 'uyu',  amountKeyLowerCase: 'amount_uyu', maxAmountKeyLowerCase: 'max_amount_uyu', amountKey: 'amountUyu', maxAmountKey: 'maxAmountUyu', originalTotalKeyLowerCase: 'original_total_uyu', originalTotalKey: 'originalTotalUyu', totalKeyLowerCase: 'total_uyu', priceKeyLowerCase: 'price_uyu', totalKey: 'totalUyu', priceKey: 'priceUyu', photoPriceKeyLowerCase: 'photo_price_uyu', photoPriceKey: 'photoPriceUyu', label: 'UYU', sign: '$' },
]

export const commonEmailDomains = ['gmail', 'hotmail', 'yahoo', 'icloud']
export const commonEmailDomainsSuffix = ['ar', 'br', 'com', 'eu', 'uk', 'org']
export const commonEmailChars = ['@', '-', '_', '.', '&', '?']

export const paymentProcessors = [
  { slug: 'decidir', label: 'Payway' },
  { slug: 'mercado_pago', label: 'Mercado Pago' },
  { slug: 'redsys', label: 'Redsys' },
  { slug: 'transbank', label: 'Transbank' },
  { slug: 'pix', label: 'Pix' },
]

export const invoiceTypes = [
  { slug: 'pdf', label: 'PDF' },
  { slug: 'afip', label: 'AFIP' },
  { slug: 'arca', label: 'ARCA' },
]

export const addOnAvailabilities = [
  { slug: 'web', label: 'web' },
  { slug: 'store', label: 'store' },
]

export const addOnRequirements = [
  { slug: 'address', label: 'address' },
  { slug: 'color', label: 'color' },
  { slug: 'phone', label: 'phone' },
]

export const langFlagsOptions = [
  { slug: 'america', label: 'america' },
  { slug: 'europe', label: 'europe' },
]
